module.exports = __webpack_public_path__ + "img/tuijian@2x.abc62dfe.svg";